import React, { memo, useCallback, useState, useEffect, useRef } from 'react';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import { GoogleMap, useLoadScript, MarkerClusterer, Marker } from '@react-google-maps/api';
import classnames from 'classnames';
import { useWeb5Context } from "../../../../../lib/Web5Context";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'Map');
const ZOOM = 7;
const DEFAULT_CENTER = {
  lat: 43.603657052072826,
  lng: 1.4458858603465397
};
const Map = /*#__PURE__*/memo(_ref => {
  let {
    googleMapsApiKey,
    zoom = ZOOM,
    data
  } = _ref;
  const classes = useStyles();
  const [center, setCenter] = useState(DEFAULT_CENTER);
  const isFirstRender = useRef(true);
  const {
    pathImage
  } = useWeb5Context();
  const isValidLatitude = useCallback(lat => {
    return typeof lat === 'number' && lat >= -90 && lat <= 90;
  }, []);
  const isValidLongitude = useCallback(lng => {
    return typeof lng === 'number' && lng >= -180 && lng <= 180;
  }, []);
  const isValidCoordinate = useCallback((lat, lng) => {
    return isValidLatitude(lat) && isValidLongitude(lng);
  }, [isValidLatitude, isValidLongitude]);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      if (data !== null && data !== void 0 && data.length && data[0].latitude && data[0].longitude && isValidCoordinate(data[0].latitude, data[0].longitude)) {
        setCenter({
          lat: data[0].latitude,
          lng: data[0].longitude
        });
        return;
      } else if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          setCenter({
            lat: position.coords.latitude,
            lng: position.coords.longitude
          });
        }, () => {
          return;
        });
      }
    }
  }, [data, isValidCoordinate]);
  const {
    isLoaded
  } = useLoadScript({
    googleMapsApiKey: googleMapsApiKey
  });
  const containerStyle = {
    width: '100%',
    height: '100%'
  };
  const createLocation = useCallback((lat, lng) => {
    return {
      lat,
      lng
    };
  }, []);
  const stopPropagation = useCallback(e => {
    if (e) e.stopPropagation();
  }, []);
  const options = {
    streetViewControl: false,
    mapTypeControl: false,
    fullscreenControl: false,
    minZoom: 3,
    maxZoom: 18,
    restriction: {
      latLngBounds: {
        north: 85,
        south: -85,
        west: -180,
        east: 180
      },
      strictBounds: true
    }
  };
  const CLUSTERS_STYLES = [{
    width: 50,
    height: 51,
    url: pathImage + 'cluster-agg-icon-a.png',
    textColor: 'white'
  }, {
    width: 61,
    height: 61,
    url: pathImage + 'cluster-agg-icon-b.png',
    textColor: 'white'
  }, {
    width: 74,
    height: 74,
    url: pathImage + 'cluster-agg-icon-c.png',
    textColor: 'white'
  }, {
    width: 81,
    height: 82,
    url: pathImage + 'cluster-agg-icon-d.png',
    textColor: 'white'
  }, {
    width: 91,
    height: 92,
    url: pathImage + 'cluster-agg-icon-e.png',
    textColor: 'white'
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.root, 'fm-forceBI-map'),
    onMouseDown: stopPropagation
  }, isLoaded && (data === null || data === void 0 ? void 0 : data.length) && /*#__PURE__*/React.createElement(GoogleMap, {
    mapContainerStyle: containerStyle,
    center: center,
    zoom: zoom,
    options: options
  }, /*#__PURE__*/React.createElement(MarkerClusterer, {
    styles: CLUSTERS_STYLES
  }, clusterer => data.map((item, index) => /*#__PURE__*/React.createElement(Marker, {
    key: index,
    position: createLocation(item.latitude, item.longitude),
    clusterer: clusterer
  })))));
});
export default Map;